export { StrongCache } from "./strong.js";
export { WeakCache } from "./weak.js";
